import Enum from "../../enum";
import {
    DATA_TYPE,
    COMMUNICATION_FORMAT,
    DATA_FORMAT,
    DOMAIN_MAX_LENGTH,
} from "../constants";

export const sealSchema = {
    "seal": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "externalId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.EXTERNAL_ID,
            value: "",
        },
        "name": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NAME,
            value: "",
        },
        "description": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DESCRIPTION,
            value: "",
        },
        "data": {
            type: DATA_TYPE.TEXT,
            value: null,
        },
        "fileSize": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "fileHash": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.FILE_HASH,
            value: "",
        },
        "state": {
            type: DATA_TYPE.ENUM,
            enum: "SealState",
            value: Enum.BE_SEAL_STATE.ACTIVE,
        },
        "type": {
            type: DATA_TYPE.ENUM,
            enum: "SealType",
            value: "",
        },
        "status": {
            type: DATA_TYPE.ENUM,
            enum: "SealStatus",
            value: Enum.BE_SEAL_STATUS.NONE,
        },
        "statusDate.deletedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "enabledSealApproverFullApproval": {
            type: DATA_TYPE.BOOLEAN,
            value: false,
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "updatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        }
    },

    "sealHistory": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "action": {
            type: DATA_TYPE.ENUM,
            enum: "SealHistoryAction",
            value: null,
        },
        "source": {
            type: DATA_TYPE.ENUM,
            enum: "HistorySource",
            value: null,
        },
        "actorId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "actorName": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NAME,
            value: "",
        },
        "sealId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "userAgent": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.USER_AGENT,
            value: "",
        },
        "ip": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.IP,
            value: "",
        },
        "reason": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.MESSAGE,
            value: "",
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "changes": {
            type: DATA_TYPE.ARRAY,
            value: [],
        },
        "message": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.MESSAGE,
            value: "",
        },
    },

    "sealHistoryDetail": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "action": {
            type: DATA_TYPE.ENUM,
            enum: "SealHistoryAction",
            value: null,
        },
        "changes": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "message": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.MESSAGE,
            value: "",
        },
        "field": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "target": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "before": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "after": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
    },

    "sealApprover": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "departmentId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "memberId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "sealId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "order": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "updatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
    },

    "sealManager": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "departmentId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "memberId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "sealId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "updatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
    },

    "sealLedger": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "name": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NAME,
            value: "",
        },
        "requestReason": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.MESSAGE,
            value: "",
        },
        "status": {
            type: DATA_TYPE.ENUM,
            enum: "SealLedgerStatus",
            value: null,
        },
        "rejectReason": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.MESSAGE,
            value: "",
        },
        "convertStatus": {
            type: DATA_TYPE.ENUM,
            enum: "SealLedgerConvertStatus",
            value: null,
        },
        "memberId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "referenceType": {
            type: DATA_TYPE.ENUM,
            enum: "SealLedgerReferenceType",
            value: null,
        },
        "referenceIdJson": {
            type: DATA_TYPE.TEXT,
            value: null,
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "updatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
    }
} as const;
